import './App.css';
import Dashboard from "./Pages/Dashboard";

function App() {
  return (
    <div className="App">
    <Dashboard/>
    </div>
  );
}

export default App;
